import React, { useEffect, useState } from "react";
import AdminSideBar from "../component/admin/AdminSideBar";
import AdminUsers from "../component/admin/AdminUsers";
import AdminChangePW from "../component/admin/AdminChangePW";
import AdminUserList from "../component/admin/AdminUserList";
import AdminPostList from "../component/admin/AdminPostList";
import AdminAnalytics from "../component/admin/AdminAnalytics";
import AdminAnnouncements from "../component/admin/AdminAnnouncement";
import { API_URL } from "../api/APIUrl";

function Admin() {
  const [users, setUsers] = useState([]);
  const [visibleChangePw, setVisibleChangePw] = useState(true);
  const [visibleCards, setVisibleCards] = useState(true);
  const [visibleUserList, setVisibleUserList] = useState(false);
  const [visiblePostList, setVisiblePostList] = useState(false);
  const [visibleAnalytics, setVisibleAnalytics] = useState(false);
  const [visibleAnnouncements, setVisibleAnnouncements] = useState(false);
  const [sideVisible, setSideVisible] = useState(false);

  const fetchdata = async () => {
    const res = await fetch(`${API_URL}/api/users`);
    const res2 = await res.json();
    setUsers(res2);
  };

  useEffect(() => {
    fetchdata();
  }, []);

  const VisibilityCard = (bool) => setVisibleCards(bool);
  const VisibilityUserList = (bool) => setVisibleUserList(bool);
  const VisibilityPostList = (bool) => setVisiblePostList(bool);
  const VisibilityChangePw = (bool) => setVisibleChangePw(bool);
  const VisibilityAnalytics = (bool) => setVisibleAnalytics(bool);
  const VisibilityAnnouncements = (bool) => setVisibleAnnouncements(bool);

  // --- REVISED WRAPPER STYLES (FLEXBOX FIX) ---
  const adminWrapperStyle = {
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
    width: "100vw",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    color: "#212529",
    display: "flex", // Changed to flex to let components size naturally
  };

  const containerStyle = {
    display: "flex",
    width: "100%",
  };

  const mainStyle = {
    flexGrow: 1, // Forces main content to fill all remaining horizontal space
    padding: "40px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    boxShadow: "-5px 0 25px rgba(0, 0, 0, 0.01)",
  };

  const rightSectionStyle = {
    position: "fixed",
    top: "20px",
    right: "20px",
    zIndex: 999,
  };

  const menuBtnStyle = {
    backgroundColor: "#ffffff",
    border: "1px solid #e9ecef",
    borderRadius: "8px",
    padding: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  };

  return (
    <div className="admin" style={adminWrapperStyle}>
      <div className="container-admin" style={containerStyle}>
        <AdminSideBar
          VisibilityCard={VisibilityCard}
          VisibilityUserList={VisibilityUserList}
          VisibilityPostList={VisibilityPostList}
          VisibilityChangePw={VisibilityChangePw}
          VisibilityAnalytics={VisibilityAnalytics}
          VisibilityAnnouncements={VisibilityAnnouncements}
          VisibilitySide={sideVisible}
          VisibilityClose={setSideVisible}
        />

        <main style={mainStyle}>
          <AdminUsers visible={visibleCards} />
          {/* <AdminChangePW visible={visibleChangePw} /> */}
          <AdminUserList visible={visibleUserList} />
          <AdminPostList visible={visiblePostList} />
          <AdminAnalytics visible={visibleAnalytics} />
          <AdminAnnouncements visible={visibleAnnouncements} />
        </main>
      </div>
    </div>
  );
}

export default Admin;
